import { Typography } from "@packages/ds";
import styled, { css } from "styled-components";

import * as Accordion from "ds/Accordion";
import { Link as LinkDs } from "ds/Button";

export const Line = styled.div`
  display: flex;
  hr {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    margin-left: 0px !important;
    width: 100% !important;
    align-self: end !important;
    background-color: var(--mode-border-neutral-default);
  }
`;

export const AppName = styled(Typography.BodyText)`
  color: var(--section-ebony-color, var(--ebony));
  padding: 0 0 8px 0;
`;

export const AppNameWorkers = styled(Typography.BodyText)`
  color: var(--section-ebony-color, var(--ebony));
  padding-bottom: 1px;
  font-size: 13px;
`;

export const AppNameNumber = styled.span`
  color: var(--section-slate-color, var(--slate));
`;

export const RouteList = styled.ul`
  margin: 0;
  padding: 16px;
  max-height: 248px;
`;

export const RoutesWrapper = styled.div`
  padding: 0;
`;

export const ViewAllLink = styled(LinkDs)`
  line-height: 19px;
`;

export const ViewAll = styled.div`
  text-align: center;
  padding-top: 9px;
  padding-bottom: 12px;
  border-top: 1px solid var(--mode-border-neutral-weakest);
  margin-top: 12px;
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
`;

export const Link = styled(LinkDs)<{ securePath: boolean }>`
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--mode-text-neutral-default-weak);
  height: 32px;

  &:hover {
    color: var(--mode-text-primary-default);
    &::after {
      display: none;
    }
  }

  ${({ securePath }) =>
    securePath &&
    css`
      display: grid;
      align-items: center;
      grid-template-columns: max-content 24px;
      justify-content: space-between;
    `}
`;

export const RouteLinkList = styled.li`
  list-style: none;
`;

export const AccordionHeader = styled(Accordion.Header)`
  margin: 0px !important;
  display: flex;
  justify-content: space-between;
`;

export const Instance = styled(Typography.BodyText)`
  font-size: 13px;
  padding: 4px 0;
  color: var(--section-slate-color, var(--slate));
`;

export const AppNameWrapper = styled.div`
  display: flex;
  align-items: end;
  gap: 8px;
  margin-top: 8px;
`;

export const NoResultWrapper = styled.div`
  padding: 24px 0px;
  font-weight: 600;
  font-size: 14px;
`;
export const Title = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ShowAll = styled(Typography.BodyText)`
  margin: 8px 0;
`;

export const ShowAllButton = styled.button`
  margin: 0 2px;
  border: none;
  background: transparent;
  color: var(--section-color-primary-600-color, var(--color-primary-600));
  font-size: 15px;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const URLContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 16px;
  gap: 16px;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: var(--mode-text-primary-default);
  background: var(--mode-bg-primary-weakest);
  border-radius: var(--theme-br-default);
  margin: 8px 0 16px;
`;
